(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-product-cta"] && !Shopify.designMode) return;
  try {
    const initializeMobileProductCta = (root = document) => {
    root.querySelectorAll('[data-mobile-product-cta]:not([data-initialized])').forEach((bar) => {
      bar.dataset.initialized = 'true';

      const section = document.getElementById(`shopify-section-${bar.dataset.sectionId}`);
      const optionBlock = section?.querySelector('.product-info__block-item[data-block-type="variant-picker"], variant-picker');
      const buyBlock = section?.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
      const buyButton = buyBlock?.querySelector('button[type="submit"], button[name="add"]');
      const trigger = bar.querySelector('[data-mobile-product-cta-button]');

      trigger?.addEventListener('click', () => {
        if (optionBlock) {
          optionBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(() => {
            optionBlock.querySelector('select, input:not([type="hidden"]), button')?.focus({ preventScroll: true });
          }, 350);
          return;
        }

        if (buyButton && !buyButton.disabled) {
          buyButton.click();
        }
      });

      if (!buyBlock) {
        bar.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: .1 });

      observer.observe(buyBlock);
    });
  };

  initializeMobileProductCta();
  document.addEventListener('shopify:section:load', (event) => initializeMobileProductCta(event.target));
  } catch(e) { console.error(e); }
})();

})();
